<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Asset Management</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">List of Asset</h4>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              class="select-info mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedData"
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column :min-width="135" align="right" label="Actions">
              <div slot-scope="props">
                <base-button
                  @click.native="handleEdit(props.$index, props.row)"
                  class="edit btn-link"
                  type="warning"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil"></i>
                </base-button>
                <base-button
                  @click.native="handleDelete(props.$index, props.row)"
                  class="remove btn-link"
                  type="danger"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-simple-remove"></i>
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      selects: {
        simple_site: "",
        site: [
          { value: "All", label: "All" },
          { value: "Klang Valley", label: "Klang Valley" },
          { value: "Klang Valley", label: "KLIA" },
        ],
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "assetNo",
          label: "Asset No",
          minWidth: 150,
        },
        {
          prop: "assetCondition",
          label: "Asset Condition",
          minWidth: 150,
        },
        {
          prop: "site",
          label: "Site",
          minWidth: 150,
        },
        {
          prop: "location",
          label: "Location",
          minWidth: 150,
        },
      ],

      tableData: [
        {
          assetNo: "DHES 1",
          assetCondition: "Operational",
          site: "Site A",
          location: "HQ",
        },
        {
          assetNo: "DHES 245",
          assetCondition: "Breakdown",
          site: "Site B",
          location: "HQ",
        },
        {
          assetNo: "DHES 908",
          assetCondition: "Operational",
          site: "Site C",
          location: "HQ",
        },
        {
          assetNo: "DHES 789",
          assetCondition: "Breakdown",
          site: "Site D",
          location: "HQ",
        },
        {
          assetNo: "DHES 708",
          assetCondition: "Operational",
          site: "Site E",
          location: "HQ",
        },
        {
          assetNo: "DHES 213",
          assetCondition: "Operational",
          site: "Site F",
          location: "HQ",
        },
      ],
      searchedData: [],
      fuseSearch: null,
    };
  },

  methods: {
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill",
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["assetNo", "assetCondition", "site"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    searchCustomer(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
